import DocumentType from 'documents/DocumentType'
import ModalViewModel from 'infra/ModalViewModel'
import isDocumentRequestEnabled from 'jobs/document-requests/DocumentRequestFeatureToggle'
import Job from 'jobs/Job'
import JobProgressionStore from 'jobs/progression/JobProgressionStore'
import { action, makeObservable, override } from 'mobx'
import { task } from 'mobx-task'
import { Nullable } from 'types/definitions'

export class OpenItemsDialogViewModel extends ModalViewModel {
  constructor(
    private progressionStore: JobProgressionStore,
    private promptForDocumentRequest: () => Promise<Nullable<DocumentType[]>>,
    private job: Job,
  ) {
    super()
    makeObservable(this)
  }

  @action.bound
  answerOpenItems = task.resolved(async () => {
    await this.progressionStore.setOpenItemsProgression(this.job.id)
    this.close()
  })

  @override
  async show() {
    const documentRequestEnabled = isDocumentRequestEnabled()

    if (!documentRequestEnabled) {
      super.show()
      return
    }

    const result = await this.promptForDocumentRequest()
    if (result) {
      await this.answerOpenItems()
    }
  }
}
